import * as React from 'react';
import { SearchContextManager } from '@giphy/react-components';

import './gifPicker.sass';
import { IGif } from '@giphy/js-types';

import { GifPickerContent } from './gifPickerContent';

const GIPHY_API_KEY = process.env.REACT_APP_GIPHYAPIKEY ?? '';

interface IGifPickerProps {
    onSelect: (gif: IGif) => void;
    searchPlaceholder?: string;
    width?: number;
    columns?: number;
}

export const GifPicker: React.FunctionComponent<IGifPickerProps> = ({
    onSelect,
    searchPlaceholder = 'Search GIFs',
    width = 360,
    columns = 3,
}) => {
    if (!GIPHY_API_KEY) {
        return (
            <div className="gif-picker gif-picker--unconfigured" role="alert">
                GIF picker is not configured. Contact an administrator.
            </div>
        );
    }

    return (
        <div className="gif-picker">
            <SearchContextManager
                apiKey={GIPHY_API_KEY}
                options={{ rating: 'g' }}
                shouldDefaultToTrending={true}
            >
                <GifPickerContent
                    onSelect={onSelect}
                    searchPlaceholder={searchPlaceholder}
                    width={width}
                    columns={columns}
                />
            </SearchContextManager>
        </div>
    );
};

export default GifPicker;
